export default [{
    "date": 1445438181081,
    "row": 4,
    "col": 5,
    "squares": [
        [1, 2, "#1A3540"],
        [2, 1, "#1A3540"],
        [2, 2, "#1A3540"],
        [3, 2, "#1A3540"],
        [3, 3, "#1A3540"],
        [3, 4, "#1A3540"],
        [2, 5, "#1A3540"],
        [4, 4, "#1A3540"],
        [4, 2, "#1A3540"]
    ]
}, ]
